import { EDGE_TYPE, EHCalTempRotateObj, EHChangeCrossCursor, EventGraphBase, EventGraphNode, EventGraphNodeAND, EventGraphNodeNotice, EventGraphNodeRender, EventGraphNodeSwitch, EventHanderCalAllBoundingBox, EventHanderShowAllInRect, EventHandlerCalPointerDown, EventHandlerCalPointerMove, EventHandlerCalPrimitiveInView, EventHandlerCalTempMoveObj, EventHandlerCalTempMovePri, EventHandlerCalTempRotatePri, EventHandlerCapture, EventHandlerCmdEnd, EventHandlerConfirm, EventHandlerDisableSelect, EventHandlerEditPri, EventHandlerEmptySelect, EventHandlerGeneratePri, EventHandlerGrid, EventHandlerHelpLine, EventHandlerInitCapture, EventHandlerNumberInput, EventHandlerObjectInput, EventHandlerOnZoomAll, EventHandlerOrthoPolar, EventHandlerSettingOrthoPoint, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerQuickGenAxisNet } from "../event-handler/EHQuickGenAxisNet";
import { EventHandlerGenGridPoint } from "../event-handler/EHGenGridPoint";
import { EventHandlerRotateQuickAxisNet } from "../event-handler/EHRotateQuickAxisNet";
import { EventHandlerMoveQuickAxisNet } from "../event-handler/EHMoveQuickAxisNet";
import { EventHandlerMoveTempAxisNet } from "../event-handler/EHMoveTempAxisNet";

/**
 * 快速生成轴网
 */
export class EventGraphQuickGenAxisNet extends EventGraphBase {

    /**
     * quickgenaxisnet指令 用于注册事件图
     */
    static cmd = 'QUICKGENAXISNET';

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "",
                option: 'GRID',
                inputTypes: [PythaEventName.OBJECT]
            }]
        });
        const node3 = new EventGraphNode(this, EventHandlerObjectInput);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNode(this, EventHandlerInitCapture);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node10 = new EventGraphNode(this, EventHandlerCapture);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "确定放置点",
                option: 'P',
                inputTypes: [PythaEventName.POINTER_DOWN]
            }]
        });
        const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node15 = new EventGraphNode(this, EventHandlerConfirm);
        const node16 = new EventGraphNode(this, EHChangeCrossCursor);
        const node19 = new EventGraphNodeSwitch(this, () => {
            const grid = this.cache.inputObject['GRID'];
            if (!grid?.x && !grid?.y) {
                return [1]
            } else {
                return [0]
            }
        });
        const node26 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node29 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "指定旋转角度<0>",
                option: 'A',
                inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
            }]
        });
        const node30 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node31 = new EventGraphNode(this, EventHandlerNumberInput);
        const node32 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.data['step'] == 2) {
                return [1]
            } else {
                return [0]
            }
        });
        const node34 = new EventGraphNode(this, EventHandlerHelpLine);
        const node35 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node36 = new EventGraphNode(this, EHCalTempRotateObj);
        const node37 = new EventGraphNode(this, null);
        const node38 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node41 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node42 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node45 = new EventGraphNode(this, EventHandlerRotateQuickAxisNet);
        const node46 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node47 = new EventGraphNode(this, EventHandlerQuickGenAxisNet);
        const node48 = new EventGraphNode(this, EventHanderCalAllBoundingBox);
        const node50 = new EventGraphNode(this, EventHanderShowAllInRect);
        const node51 = new EventGraphNode(this, EventHandlerMoveTempAxisNet);
        const node52 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.data['step'] == 1) {
                return [0]
            } else {
                return [1]
            }
        });
        const node53 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node54 = new EventGraphNode(this, EventHandlerMoveQuickAxisNet);
        const node55 = new EventGraphNode(this, EventHandlerGrid);
        const node56 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node57 = new EventGraphNode(this, EventHandlerGrid);
        const node58 = new EventGraphNode(this, EventHandlerGrid);
        const node59 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node60 = new EventGraphNode(this, EventHandlerGenGridPoint);
        const node61 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);

        this.addEdge(node2, node3);
        this.addEdge(node1, node8);
        this.addEdge(node8, node9);
        this.addEdge(node9, node10);
        this.addEdge(node13, node11);
        this.addEdge(node10, node14);
        this.addEdge(node1, node15);
        this.addEdge(node16, node13);
        this.addEdge(node26, node27);
        this.addEdge(node27, node7);
        this.addEdge(node29, node30);
        this.addEdge(node29, node31);
        this.addEdge(node15, node32);
        /**当前步骤不为2*/
        this.addEdge(node32, node7);
        this.addEdge(node35, node2);
        this.addEdge(node34, node36);
        this.addEdge(node36, node37);
        this.addEdge(node37, node38);
        this.addEdge(node41, node26);
        this.addEdge(node1, node42);
        this.addEdge(node42, node35);
        this.addEdge(node31, node45);
        this.addEdge(node30, node45);
        this.addEdge(node46, node41);
        this.addEdge(node3, node47);
        this.addEdge(node51, node53);
        /**当前步骤为1*/
        this.addEdge(node52, node51);
        this.addEdge(node50, node55);
        this.addEdge(node55, node56);
        this.addEdge(node56, node29);
        this.addEdge(node14, node52);
        this.addEdge(node47, node57);
        this.addEdge(node57, node19);
        this.addEdge(node54, node58);
        this.addEdge(node58, node48);
        this.addEdge(node31, node30, EDGE_TYPE.STOP);
        this.addEdge(node30, node31, EDGE_TYPE.STOP);
        this.addEdge(node48, node50);
        this.addEdge(node54, node51, EDGE_TYPE.STOP);
        this.addEdge(node11, node59);
        this.addEdge(node59, node54);
        this.addEdge(node45, node60);
        this.addEdge(node60, node46);
        /**存在X或Y坐标*/
        this.addEdge(node19, node61);
        this.addEdge(node61, node48);
        /**XY坐标均不存在*/
        this.addEdge(node19, node16);
        /**当前步骤为2*/
        this.addEdge(node32, node45);
        /**当前步骤为2*/
        this.addEdge(node52, node34);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/129


        node54.needExtraFuncAfter = () => {
            node51.dispose();
        }
    }
}

